import Card from './Card.vue';

// @ts-ignore
Card.install = (Vue) => {
  Vue.component((Card as any).options.name, Card);
};

export default Card;
